import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { FormLabel } from '../FormLabel'
import { SelectButton, SelectMenuContent } from './components'
import { useFormSelect } from './useFormSelect'

interface Props {
  name: string
  label: string
  value: string
  canEdit: boolean
  readOnly: boolean
  cnClassName: string
  onChange: (value: string) => void
}

export const FormSelect: React.FC<Props> = ({
  name,
  label,
  value,
  canEdit,
  readOnly,
  cnClassName,
  onChange,
}) => {
  const { selected, handleOnClick } = useFormSelect(value, onChange)

  const disabled = !canEdit || readOnly

  return (
    <div className={cnClassName}>
      <FormLabel name={name} label={label} />

      <DropdownMenu.Root
        align="start"
        onClick={handleOnClick}
        content={SelectMenuContent}
      >
        <SelectButton disabled={disabled} title={selected} />
      </DropdownMenu.Root>
    </div>
  )
}
